import React from "react"
import {FieldManagementPreviewProps} from "../../../render/management-preview";
import FieldView from "../../../render/view";


export default function FieldText_ManagementPreview(props: FieldManagementPreviewProps) {

    const model:any = {}
    model[props.field.fieldId] = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi pellentesque quam magna, ac pulvinar nunc ornare sed."

    return (
        <FieldView field={props.field} model={model} />
    )

}